/** 약관/개인정보 wrap HTML 로드 후 실제 본문 높이에 맞춤 (iframe 아래 빈 스크롤 방지) */
export function resizeLegalIframe(e) {
  const iframe = e.currentTarget;
  try {
    const doc = iframe.contentDocument || iframe.contentWindow?.document;
    if (!doc?.body) return;
    const h = Math.max(doc.documentElement.scrollHeight, doc.body.scrollHeight);
    iframe.style.height = `${h}px`;
  } catch {
    /* ignore */
  }
}
